import RestResource from '../rest.service';

export default class PlotPermissionsService extends RestResource {
  setPlot(plotId) {
    this.parents = [];
    this.parents.push(plotId);
    return this;
  }

  map(payload) {
    return {
      plot_id: payload.plotId,
      shareable_id: payload.shareableId,
      shareable_type: payload.shareableType,
      read: payload.read,
      write: payload.write,
    };
  }

  constructor() {
    super('plots/$0/permissions');
  }
}
